<template>
  <div class="turn-grid">
    <div class="position-relative h-100">
      <turn
        ref="book"
        :options="{
          initPage: 1,
          shadow: false,
          gradients: false,
        }"
      >
        <div class="flip_page_double hard">
          <img src="/assets/images/page/000.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/001.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/002.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/003.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/004.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/005.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/006.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/007.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/008.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/009.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/010.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/011.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/012.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/013.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/014.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/015.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/016.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/017.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <img src="/assets/images/page/018.webp" alt />
        </div>
        <div class="flip_page_double hard">
          <a href="https://valhallaverse.gitbook.io/whitepaper/" target="_blank">
            <img src="/assets/images/page/019.webp" alt />
          </a>
        </div>
        <div class="flip_page_double hard">
          <a href="https://valhallaverse.gitbook.io/whitepaper/" target="_blank">
            <img src="/assets/images/page/020.webp" alt />
          </a>
        </div>
      </turn>
      <div class="page-arrow page-prev" @click="prevPage" id="prev">
        <img src="/assets/images/arrow-left.png" alt class="img-fluid" />
      </div>
      <div class="page-arrow page-next" @click="nextPage" id="next">
        <img src="/assets/images/arrow-right.png" alt class="img-fluid" />
      </div>
    </div>
  </div>
</template>

<script>
import { Turn } from "vue-turnjs";
export default {
  components: {
    Turn,
  },
  data() {
    return {
      pageCount: 23,
    };
  },
  mounted() {
    this.$refs.book.goTo(1);
    this.$refs.book.currentPage = 1;
  },
  methods: {
    prevPage() {
      let page = this.$refs.book.currentPage - 2;
      this.$refs.book.goTo(page > 0 ? page : 1);
    },
    nextPage() {
      let page = this.$refs.book.currentPage + 2;
      this.$refs.book.goTo(page < this.pageCount + 1 ? page : this.pageCount);
    },
  },
};
</script>

<style lang="scss" scoped>
.turn-grid {
  width: 141.76vh;
  height: 100vh;
  max-width: 1205px;
  max-height: 850px;
  overflow: hidden;
  background: url("/assets/images/page/book.webp") center center 100%;
  background-size: contain;
  margin-left: auto;
  margin-right: auto;
}
.flip_page_double {
  width: 141.76vh;
  height: 100vh;
  max-width: 1205px;
  max-height: 850px;
  text-align: center;
  vertical-align: middle;
  img {
    max-width: 100%;
  }
}
.page-arrow {
  position: absolute;
  width: 46px;
  height: 66px;
  padding: 3px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  &.page-prev {
    left: 0;
  }
  &.page-next {
    right: 0;
  }
  &:hover {
    -webkit-filter: drop-shadow(0px 0px 3px #fff);
    filter: drop-shadow(0px 0px 3px #fff);
  }
}
</style>
